import { render, staticRenderFns } from "./CompanyPropertyList.vue?vue&type=template&id=d81a8344&"
import script from "./CompanyPropertyList.vue?vue&type=script&lang=js&"
export * from "./CompanyPropertyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports